import * as React from 'react';
import KNB from '@wmfe/mach-pro-knb';
import * as LX from '@/pages/homepage/preheat/request/lx';
import '@/pages/homepage/preheat/noservice/index.css';
import { i18nClient } from '@sailor/i18n-mach-pro/lib';
import { HOME_PAGE_ERROR_CODE } from '@/src/pages/homepage/home_page_main/utils/constant';
import { HomePageLoganType, logan } from '@common/utils/Logan';
import { callModule } from '@/shared_worker_global/market/util';
import { PreheatMonitor } from '@/pages/homepage/preheat/utils/monitor';
// ----- mpweb适配origin -----
// ----- mpweb适配change -----
import { setStoredCurrLocation, storeLastSelected } from '@m2h/common/utils/location';
import { LocatinStatus } from '@/src/sub_packages/homepage/address_bar/constant';
// ----- mpweb适配       -----

const WMRouter = Mach.requireModule('Router');
interface State {
  styles: {
    pageWidth: number;
    pageHeight: number;
    bgiWidth: number;
    bgiHeight: number;
    titleTopMargin: number;
  };
  guideWord: {
    title: string;
    subTitle: string;
    button: string;
    exploreText: string;
    linkUrl: string;
    secondTitle: string;
    secondSubTitle: string;
  };
  logined: boolean;
  code?: number;
  height: number;
}

interface Props {
  apiData?: any;
  nativeData?: any;
  height: number;
}

/**
 * 预热页面
 * 201003221 已登录
 * 201003222 未登录
 */
const prePageLoginedCode = HOME_PAGE_ERROR_CODE.PRE_PAGE_LOGIN_CODE;
const prePageNonLoginCode = HOME_PAGE_ERROR_CODE.PRE_PAGE_NO_LOGIN_COE;

/**
 * 未开城
 * 201003216 已登录
 * 201003217 未登录
 */
const loginedCode = HOME_PAGE_ERROR_CODE.LOGIN_CODE;
const noLoginedCode = HOME_PAGE_ERROR_CODE.NO_LOGIN_CODE;

// 无供给
const noSupplyArea = HOME_PAGE_ERROR_CODE.NO_SUPPLY_AREA;
// 无数据
const noData = HOME_PAGE_ERROR_CODE.NO_DATA;

const SLUserAddress = Mach.requireModule('SLUserAddress');
const SLLocation = Mach.requireModule('SLLocation');

export default class GuidePage extends React.Component<Props, State> {
  guideInfo?: any;
  code: number = HOME_PAGE_ERROR_CODE.NO_DATA;
  message?: string;
  viewRef: React.RefObject<any> = React.createRef();
  bgiWidth: number;
  bgiHeight: number;
  unLoginHeight = 280;
  loginHeight = 160;
  monitor = new PreheatMonitor();

  constructor(props: Props) {
    super(props);
    const pageWidth = Mach.env?.screenWidth || 375;
    const pageHeight = Math.ceil(Mach.env?.screenHeight - Mach.env?.softMenuBarHeight);
    // 按比例缩放
    const bgiHeight = (412 / 375) * pageWidth;
    const titleTopMargin = bgiHeight / 10;
    this.bgiWidth = pageWidth;
    this.bgiHeight = bgiHeight;
    // this.state = {
    //   styles: {
    //     pageWidth,
    //     pageHeight,
    //     bgiWidth: pageWidth,
    //     bgiHeight,
    //     titleTopMargin,
    //   },
    //   guideWord: null as any,
    //   logined: false,
    // };
    // this.parseData();
  }

  reportMV = (logined) => {
    LX.ggMV(logined);
    if (!logined) {
      LX.loginMV();
    }
  };

  // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
  //   let data = this.props.apiData?.json_data ? this.props.apiData?.json_data : (this.props.nativeData ?? {})
  //   const {code, sceneCode} = data
  //   let curCode = code ?? sceneCode
  //   if (curCode !== this.code) {
  //     this.parseData()
  //   }
  // }

  parseData() {
    const data = this.props.apiData?.json_data ? this.props.apiData?.json_data : this.props.nativeData;
    if (!data) {
      return;
    }
    const {
      code, sceneCode, message, guideInfo, guideWord
    } = data;
    this.message = message;
    this.updateState(code ?? sceneCode, guideInfo, guideWord);
  }

  updateState= (code, guideInfo, guideWord) => {
    this.guideInfo = guideInfo;
    const logined = code === prePageLoginedCode || code === loginedCode;
    this.setState({
      guideWord: {
        ...guideWord,
      },
      logined,
      code
    });

    if (this.code !== code) {
      this.code = code;
      if (this.isNoService()) {
        this.reportMV(logined);
      }
    }
  }

  handleLogin = () => {
    KNB && KNB?.login({ success(res) {}, fail(err) {} });
  };

  onClickButton = () => {
    if (this.isLogin()) {
      this.onClickGoView();
      return;
    }
    // 登录后点击 去逛逛 也会进入onClickButton但会从上方判断return
    // 因此从这里开始都是非登录状态点击 去登录 的逻辑
    this.monitor.reportClickLogin(this.code);
    LX.loginMC();
    this.handleLogin();
  };

  getGoNewHornConfig = () => {
    const Horn = Mach.requireModule('SLCHorn');
    const config = Horn?.getAppConfig?.() || {};
    return typeof (config.isNewAddressPopup) !== 'boolean' || config.isNewAddressPopup;
  }

  onClickGoView = () => {
    this.monitor.reportClickExplore(this.code);
    LX.ggMC(this.isLogin());
    const guideInfo = this.guideInfo;

    const isNewPopup = this.getGoNewHornConfig();
    let targetUrl;
    // ----- mpweb适配origin -----
    // if (isNewPopup) {
    // ----- mpweb适配change -----
    // 登录了才跳新版，去选地址
    const currentLocation = {
      ...SLLocation.defaultLocation(),
      locateStatus: LocatinStatus.selectedLocation,
    };
    setStoredCurrLocation(currentLocation);
    storeLastSelected(currentLocation);
    // Mach.requireModule('SLUserAddress').didSelectLocation(currentLocation);

    // if (isNewPopup && this.isLogin()) {
    if (isNewPopup) {
      // ----- mpweb适配       -----
      const bundleName = 'mach_pro_sailor_c_address_select_popup';
      let cid = this.props.apiData.json_data?.cid;
      if (!cid) {
        switch (Mach.env.bundleName) {
          case 'mach_pro_sailor_c_pick_up_page_main':
            cid = 'c_sailor_c_m5n64ar9';
            break;
          default:
            break;
        }
      }
      const data: any = {
        scene: 5,
        cid,
      };
      const jsonData = encodeURIComponent(JSON.stringify(data));
      // 如有url，跳转链接； 如无url，则走默认供给地址弹窗逻辑
      targetUrl = guideInfo.scheme || `sailorc://keeta.com/machproalert?bundle_name=${bundleName}&data=${jsonData}`;
    } else {
      if (!guideInfo || !guideInfo.areaInfos) {
        SLUserAddress?.didSelectLocation(SLLocation.defaultLocation());
        return;
      }
      // 默认兜底url
      targetUrl = 'sailorc://keeta.com/machproalert?bundle_name=mach_pro_sailor_c_service_address_popup';
      let paramsData = '';
      if (guideInfo.scheme) {
        // 如有url，跳转链接
        targetUrl = guideInfo.scheme;
      } else {
        // 如无url，则走默认供给地址弹窗逻辑
        const encodeData = encodeURIComponent(JSON.stringify(this.guideInfo));
        paramsData = `&data=${encodeData}`;
      }
      targetUrl += paramsData;
    }

    callModule(
      'Router',
      'navigateTo',
      (result) => {
        if (!result.success) {
          console.log('navigate error: c_area_preheat ~~~');
        }
      },
      targetUrl,
      {}
    );
  };

  /**
   * 加载非预热页
   */
  renderNoServicePage = (guideWord) => (this.isLogin() ? this.renderNoServiceLoginPage(guideWord) : this.renderNoServiceUnLoginPage(guideWord))

  /**
   * 非预热页-已登录
   */
  renderNoServiceLoginPage = (guideWord) => {
    const bgiWidth = Mach.env?.screenWidth || 375;
    const bgHeight = (412 / 375) * bgiWidth;
    return (
      <view className="page-login-container" style={{ height: this.props.height }}>
        <view>
          <image
            className="noservice-login-image"
            src="assets://preheat/guide_not_service.png"
            style={{
              width: bgiWidth,
              height: bgHeight - bgHeight / 3,
            }}
          />
        </view>

        <view className="login-main">
          <view className="below-img-text-view">
            {/* 无服务文案 */}
            {guideWord?.noServiceInfo && <text className="no-service-info-text" content={guideWord?.noServiceInfo} />}
            {/* 利益点文案 */}
            {guideWord?.benefitInfo && <text className="benefit-info-text" content={guideWord?.benefitInfo} />}
          </view>
          <view className="login-conatiner">
            <view className="noservice-go-container" style={{ backgroundColor: guideWord?.buttonColor || '#FFEA00' }} onClick={this.onClickButton}>
              <text
                className="noservice-go"
                content={guideWord.button ?? i18nClient.getText('outservice_guide_go_experience') ?? ''}
              />
            </view>
          </view>
        </view>

      </view>
    );
  }

  onLayout = () => {
    const height = this.viewRef.current?.measureInWindow()?.height;
    console.log(`height = ${height}`);
    this.setState({
      height
    });
  }

  /**
   * 非预热页-未登录
   */
  renderNoServiceUnLoginPage = (guideWord) => {
    const bottom = Mach.env.navigationBarHeight + 100;
    const bgiWidth = Mach.env?.screenWidth || 375;
    const bgiHeight = (412 / 375) * bgiWidth - bottom;
    return (
      <view className="page-container" style={{ height: this.props.height }}>
        <image
          className="noservice-image"
          src="assets://preheat/guide_not_service.png"
          style={{
            width: bgiWidth,
            height: bgiHeight,
          }}
        />

        {this.renderSubView(guideWord)}
      </view>
    );
  }

  renderSubView = (guideWord) => (
    <view className="sub-view">
      {/* 无服务文案 */}
      {guideWord?.noServiceInfo && <text className="noservice-title" content={guideWord?.noServiceInfo} />}

      <view className="unlogin-conatiner">
        {/* 利益点文案 */}
        {guideWord?.benefitInfo && <text className="noservice-subtitle" content={guideWord.benefitInfo} />}
        <view className="noservice-unlogin-go-container" style={{ backgroundColor: guideWord?.buttonColor || '#FFEA00' }} onClick={this.onClickButton}>
          <text
            className="noservice-unlogin-go"
            content={guideWord.button ?? i18nClient.getText('outservice_guide_go_experience') ?? ''}
          />
        </view>

        <view className="noservice-gg-view" onClick={this.onClickGoView}>
          <text className="gg-text" content={guideWord.exploreText} />
          <image className="gg-icon" autoRTL src="assets://preheat/icon_arrow_right.png" />
        </view>
      </view>
    </view>
  )

  isNoService = () => this.code === loginedCode || this.code === noLoginedCode

  isLogin = () => this.code === loginedCode

  render() {
    const data = this.props.apiData?.json_data ? this.props.apiData?.json_data : this.props.nativeData;
    if (!data) {
      logan(HomePageLoganType.PreHeat, {
        msg: 'no_serveice_data_is_null',
      });
      return <view />;
    }
    const {
      code, sceneCode, message, guideInfo, guideWord
    } = data;
    this.message = message;
    this.guideInfo = guideInfo;
    if (!guideWord) {
      logan(HomePageLoganType.PreHeat, {
        msg: 'no_serveice_guide_word_is_null',
        sceneCode
      });
      return <view />;
    }
    const curCode = code ?? sceneCode;
    if (this.code !== curCode) {
      this.code = curCode;
      if (this.isNoService()) {
        this.reportMV(this.isLogin());
      }
    }
    return this.renderNoServicePage(guideWord);
  }
}
